import { BoardKachel, BoardsUebersicht } from '../types';

export const BOARD_STORAGE_KEY = (benutzerId: number) => `kontor-board:${benutzerId}`;
export const VIEW_STORAGE_KEY = (benutzerId: number) => `kontor-view:${benutzerId}`;

/** Mitarbeiter der Auswahl „Mitarbeiter“: nur solche, deren Rolle ein Personen-Board hat
 *  (sonst 404 beim Laden). Bewusst nicht über alle_rollen: der Projektleiter hat keine
 *  Alle-Rollen-Sicht (alle_rollen === null), aber eine Liste seiner Mitarbeiter. */
export function waehlbareMitarbeiter(uebersicht: BoardsUebersicht): NonNullable<BoardsUebersicht['mitarbeiter']> {
  const personenBoards = uebersicht.personen_boards ?? [];
  return (uebersicht.mitarbeiter ?? []).filter(m => personenBoards.includes(m.rolle));
}

/** Zuletzt gewähltes Board, sofern es zu einer eigenen Rolle gehört; sonst der
 *  Backend-Standard (erste eigene Rolle). */
export function standardBoard(uebersicht: BoardsUebersicht, zuletzt: string | null): string | null {
  if (zuletzt) {
    if (uebersicht.rollen.includes(zuletzt)) return zuletzt;
  }
  return uebersicht.standard;
}

/** Kachel ohne Inhalt ausblenden: nur Belege/Listen, bei denen `anzahl` die Einträge
 *  zählt. Kennzahlen und Wochenplan zählen mit `anzahl` etwas anderes (fehlende Tage,
 *  Einsätze) und bleiben immer sichtbar. */
export function kachelLeer(k: BoardKachel): boolean {
  return (k.art === 'belege' || k.art === 'liste') && k.anzahl === 0 && !k.fehler;
}

export function begruessung(name: string, datum: Date): string {
  const stunde = datum.getHours();
  const gruss = stunde < 11 ? 'Guten Morgen' : stunde < 17 ? 'Guten Tag' : 'Guten Abend';
  const vorname = name.split(' ')[0];
  return `${gruss}, ${vorname}`;
}

const WOCHENTAGE = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

/** "2025-10-27" -> "Mo 27.10." (lokales Datum, kein UTC-Versatz). */
export function wochentagLabel(iso: string): string {
  const [j, m, t] = iso.split('-').map(Number);
  const d = new Date(j, m - 1, t);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${WOCHENTAGE[d.getDay()]} ${pad(t)}.${pad(m)}.`;
}

export function startView(gespeichert: string | null): 'chat' | 'management' | 'dashboards' {
  return gespeichert === 'chat' || gespeichert === 'management' || gespeichert === 'dashboards'
    ? gespeichert
    : 'dashboards';
}

/** React-Key einer Listenzeile. Eine Kachel darf Einträge verschiedener Tabellen mischen
 *  (z. B. `qualitaet_offen`: Reklamationen und Prüfungen), deren Ids kollidieren können —
 *  der Index macht den Key innerhalb der Liste eindeutig. */
export function zeilenSchluessel(index: number, id: number | string): string {
  return `${index}-${id}`;
}
